export default __webpack_public_path__ + "static/media/spinner.3931a054.svg";